export { default as BaseLabelColor } from './BaseLabelColor'
export { default as BaseLabelShade } from './BaseLabelShade'
